import React, {Component} from 'react';
import { Modal, Button, Table} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenSquare } from '@fortawesome/free-solid-svg-icons';
import { getLabelChange, getWaiveType, getWaiveBy } from '../../../resources/Utils';
import { isNullOrUndefined } from 'util';

class ViewRequestForChangeCustomer extends Component {
    render() {
        let customerProfileViewList = [];
        let bankAcctsDiff = null;
        let label = "";
        let value = null;
        if (this.props.viewChange) {
            const customerProfileHandlerViewList = this.props.viewChange.body.customerProfileHandlerViewList;
            customerProfileViewList = customerProfileHandlerViewList.map((change) => {

                if(change.key==="waiveType"){
                    value[0] = getWaiveType(value[0])
                    value[1] = getWaiveType(value[1])
                }

                if(change.key==="waiveBy"){
                    value[0] = getWaiveBy(value[0])
                    value[1] = getWaiveBy(value[1])
                }

                if(change.key === "bankAccts"){
                    bankAcctsDiff = {
                        bankAcctsOld : change.bankAcctsOld,
                        bankAcctsNew : change.bankAcctsNew
                    };
                    return null;
                }
                if(change.key.includes("bankAccts")){
                    return null;
                }

                let category = null;
                let key = null;
                value = change.value.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").split("|");

                key = change.key.split("/");

                category = getLabelChange(key[key.length-2]);
                category = isNullOrUndefined(category) ? key[key.length-2] : category;

                label = getLabelChange(key[key.length-1]);
                label = isNullOrUndefined(label) ? key[key.length-1] : label;

                return (
                <tr key={change.key}>
                    <td>{"Customer Profile: " + category + ": " + label}</td>
                    <td>{(value[0] === 'Y' || value[0] === 'N') ? getLabelChange(value[0]) : (value[0] === "" ? "-" : value[0])}</td>
                    <td>{(value[1] === 'Y' || value[1] === 'N') ? getLabelChange(value[1]) : (value[1] === "" ? "-" : value[1])}</td>
                </tr>
                );
            });
        }

        if(bankAcctsDiff){
            const label = "Customer Profile: Payment Info.: Accounts";
            const oldAccount = bankAcctsDiff.bankAcctsOld.map((acct) => {
                return <tr><td>{acct}</td></tr>
            });
            const newAccount = bankAcctsDiff.bankAcctsNew.map((acct) => {
                return <tr><td>{acct}</td></tr>
            });
            const bankAcctsRow = 
                <tr key={"bankAccts"}>
                    <td>{label}</td>
                    <td>
                        <Table striped size="sm" className="medium">
                            <tr className="font-italic text-grey">
                                <th>Account Number</th>
                            </tr>
                            {oldAccount}
                        </Table>                            
                    </td>
                    <td>
                        <Table striped size="sm" className="medium">
                            <tr className="font-italic text-grey">
                                <th>Account Number</th>
                            </tr>
                            {newAccount}
                        </Table>        
                    </td>
                </tr>
            customerProfileViewList = [...customerProfileViewList, bankAcctsRow];
        }
        return (
            <Modal show={this.props.show} onHide={this.props.onClose} size="lg">
            <Modal.Header>
                <Modal.Title className="text-scb"><FontAwesomeIcon icon={faPenSquare} className="mr-2"/>Pending for change approval</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{'overflowY': 'auto'}}>
            {this.props.approvalAction === "CREATE" && 
                "Activate customer."
            }
            {this.props.approvalAction === "DELETE" && 
                "Delete customer."
            }
            {this.props.viewChange && this.props.approvalAction === "UPDATE" && label !== "Status" &&
                <Table borderless hover>
                <thead>
                    <tr>
                    <th></th>
                    <th>Previous</th>
                    <th>Change to</th>
                    </tr>
                </thead>
                <tbody>
                    {customerProfileViewList}
                </tbody>
                </Table>
            }
            {this.props.viewChange && this.props.approvalAction === "UPDATE" &&
             label === "Status" && value && value[0] === 'A' && value[1] === 'L' &&
                "Lock User."
            }
            {this.props.viewChange && this.props.approvalAction === "UPDATE" &&
             label === "Status" && value && value[0] === 'L' && value[1] === 'A' &&
                "Unlock User."
            }
            {!this.props.viewChange && "No change pending for approval."}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={()=>this.props.onCheckerConfirm("APPROVE")} variant="success">Approve</Button>
                <Button onClick={()=>this.props.onCheckerConfirm("REJECT")}  variant="outline-danger">Reject</Button>
            </Modal.Footer>
            </Modal>
        );
    }
}

export default ViewRequestForChangeCustomer;